import React from 'react';
import SupportedBanks from '../TopBannerHome/Shared/SupportedBanks/SupportedBanks';
import SupportedPaymentsManager from '../TopBannerHome/Shared/SupportedPaymentsManager/SupportedPaymentsManager';
import { useSelector } from 'react-redux';
import { IApplicationState } from '@spinwise/spinwise-core';
import { EGuestHomepageVersions } from '../types';

interface IPaymentsProps {
  payment_methods;
}

const Payments = ({ payment_methods }: IPaymentsProps) => {
  const geo = useSelector((state: IApplicationState) => state.globalReducer?.geo);

  if (geo?.code == 'FIN' || geo?.code == 'EST') return <SupportedBanks />;

  return <SupportedPaymentsManager payment_methods={payment_methods} version={EGuestHomepageVersions.C2} />;
};

export default Payments;
